import React from 'react'
import { useDraggableSheet } from '../../../helpers/hooks';
import './Unsubscribe.scss';
import { useNavigate } from 'react-router-dom';
import { getProfilePublicPath } from '../../../helpers/profilePaths';
import ProfilePicture from '../ProfilePicture/ProfilePicture';

const Unsubscribe = ({ user, onClose, onSubmit }) => {
    const navigate = useNavigate();
    const {
        // dragOffset,
        // dragging,
        sheetStyle,
        overlayHandlers
    } = useDraggableSheet({ onClose });

    return (
        <div
            className="about-creator "
            {...overlayHandlers}
        >
            <div
                className={`sheet p-24 d-flex f-column aic jcc`}
                style={{ ...sheetStyle }}
                onClick={(e) => e.stopPropagation()}
            >
                <ProfilePicture imgUrl={user?.profilePicture} width={72} height={72} no_edit={true} handleClick={() => {
                    const p = getProfilePublicPath(user);
                    if (p) navigate(p);
                }} />
                <p className="fs-sm2 fw-bold mt-24 mb-40">Unsubscribe from {user?.userName}</p>
                <button
                    className="btn red-outline-btn btn-full aic jcc fw-extra-bold mb-24"
                    style={{ color: '#C9100E', borderColor: '#C9100E', height: '64px' }}
                    onClick={onSubmit}
                >
                    YES, UNSUBSCRIBE

                </button>
                <p className="fs-xxs fg-dark fw-bold mb-16 mt-0 c-pointer td-underline" onClick={onClose}>STAY SUBSCRIBED</p>
            </div>
        </div>
    )
}

export default Unsubscribe